import { Dimensions } from "react-native";

const { height, width } = Dimensions.get("window");

export const windowHeight = height;
export const windowWidth = width;
